import React, { CSSProperties, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import PageLayoutNew from '../../../components/main/PageLayoutNew/PageLayoutNew';
import SpinnerNew from '../../../components/main/SpinnerNew/SpinnerNew';
import { useGetProjectQuery } from '../../../generated/graphql';
import { ProjectsProvider } from '../Projects.provider';
import ProjectsRouting, { routes } from '../Projects.routing';

type ProjectProps = {
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const Project = (props: ProjectProps) => {
    const { projectId } = useParams();

    const project = useGetProjectQuery({
        variables: {
            id: projectId
        },
    });

    if (!project.data?.Project) {
        return <SpinnerNew size="large" label="Loading project..." />;
    }

    return (
        <PageLayoutNew
            routes={routes}
            pageName="Project Management"
            name={project.data.Project.name}
            subName={project.data.Project.projectSubName}
            backPath="/projects"
        >
            <ProjectsProvider project={project}>
                <ProjectsRouting />
            </ProjectsProvider>
        </PageLayoutNew>
    );
};

export default Project;